const URL = window.location.hostname === 'localhost'
            ? 'http://localhost:4040'
            : 'https://projects.barcelonacodeschool.com/pandora-commerce'

export { URL }